import API from './API';

export default {

    findUnitConversions() {
        return API.get("/unit-conversions")
    }

}
